import * as types from "../../mutation-types";
import lazyLoading from "./lazyLoading";
import candidates from "./candidates";
import trainings from "./trainings";
import documents from "./documents";
import offers from "./offers";
import events from "./events";
import staff from "./staff";
import finances from "./finances";
import pages from "./pages";
import settings from "./settings";
import lab from "./lab";

const state = {
  items: [
    {
      name: "Dashboard",
      path: "/admin",
      alias: "/admin/dashboard",
      meta: {
        icon: "fa-dashboard",
        title: "Dashboard",
        label: "Dashboard"
      },
      component: lazyLoading("dashboard", true)
    },
    staff,
    finances,
    candidates,
    documents,
    trainings,
    offers,
    events,
    pages,
    settings,
    lab
  ]
};

const mutations = {
  [types.EXPAND_MENU](state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded;
      }
    } else if (menuItem.item && "expanded" in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded;
    }
  }
};

export default {
  state,
  mutations
};
